// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"908b8451","355":"4001689b","453":"1ff4a8a6","462":"32693594","469":"f77df8a1","493":"b8bbe0d1","520":"ea9fd703","647":"8e161f7c","655":"e033036d","720":"2dbe7772","840":"ec4a816d","849":"c101f3ec","888":"507d643b","903":"3e512ff4"}[chunkId] + ".chunk.js";
};